export default __webpack_public_path__ + "static/media/PCMExplorer300.ed1ee762.jpg";